// @flow
import * as React from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import _ from 'lodash';
import { withRouter } from "react-router-dom";
import type { TPlayerWithFixture, TCoachPlayerStatsById, TPlayersById } from '../../modules/types/player';

import colors from '../../assets/css/colors';
import * as selectors from "../../modules/selectors";
import BlankPlayer from '../../assets/images/BlankPlayer.png';
import {
	TableGrid,
	TableFlexHeading,
	TableFlexBody,
	PlayerInfo,
	RotatedLabel,
	LoadingSpinner,
	JsonFetcher,
	ModalContainer,
	ModalInnerTitle,
	RoundSelector,
	WaiverOrderWidget,
	BenchTitle,
	PlayerTableCell,
	DraftTableHeader,
	DraftLegend,
	DivLikeAButton,
	PlayersOnTrade,
	PlayersTable,
	PlayerRowMenuButton,
	TeamToTeamTrade,
	OneColumnLayout,
	Tooltip,
	ConfirmationModal,
	ThToolTip, TopBar,
	AdsContainer,
	Ad,
	CoachLockIcon,
	CoachBanner
} from '../../components';
import More from '../../components/Icons/More';
import S from '../../components/Icons/S';
import D from '../../components/Icons/D';
import T from '../../components/Icons/T';
import Caution from '../../components/Icons/Caution';
import StopIcon from '../../components/Icons/Stop';
import type { TCoachStatsListReducer, TTeamsDraftTradesReducer } from '../../modules/types';
import { coach_player_stats } from '../../helpers/stats';
import { getLeagueRoundAliases } from '../../helpers/league';
import * as actions from '../../modules/actions/index';
import { BYE_ROUNDS } from '../../helpers';
import TeamHeader from './team/teamHeader';
import PlayerRowMenuTeam from './team/playerRowMenuTeam';
import Layout from './team/layout';
import TeamGameBar from './team/teamGameBar';
import TableFlexRowStyled from './team/tableFlexRowStyled';
import BlankPlayerImage from './team/blankPlayerImage';
import BlankPlayerLabel from './team/blankPlayerLabel';
import TradesMessage from './team/tradesMessage';

const basicTable = [
	{ key: 'AVG',
		prop: 'stats.avg_points',
		tooltip: 'Average Round Score' },
	{ key: 'GP',
		prop: 'stats.games_played',
		tooltip: 'Games Played' },
	{ key: 'TP',
		prop: 'stats.total_points',
		tooltip: 'Total Points Scored' },
	{ key: 'L5 AVG',
		prop: 'stats.last_5_avg',
		tooltip: 'Average Score For Last 5 Games' },
	{ key: 'PROJ',
		prop: 'stats.proj_score_actual_round',
		tooltip: 'Projected Scored For Next Match',
		is_fc: true }
];

if (BYE_ROUNDS.length) {
	basicTable.push({ key: 'BYE RD',
		prop: 'stats.bye_round_id',
		tooltip: 'Round Player’s Team has a Bye',
		is_fc: true
	});
}

const PlayerTableCellWithTooltip = styled(PlayerTableCell)`
	&:hover {
		background-color: ${colors.nrlDarkGreenHover};
		&.coach {
			background-color: ${colors.coachPurpleHover};
		}
	}
`;

const OwnershipSpan = styled.span`
	&.color1{
		color: green;
	}
	&.color-1{
		color: red;
	}
`;

const HeaderSpan = styled.span`
	text-align: center;
`;

const PlayerRowMenuNoAction = styled.div`
	font-size: 30px;
`;

const matchesPositions = (current_positions: number[], possible_positions: number[]) => {
	return _.size(_.intersection(possible_positions, current_positions)) > 0;
};

const isTrueBoth = (item_1, item_2) => item_1 && item_2;

const isAllTrue = (arr: boolean[]) => {
	let statement = true;
	arr.forEach(val => {
		const isTrue = Boolean(val);
		if(isTrue){
			statement = true;
		}
		else{
			statement = false;
		}
	} );
	return statement;
};

type TTableColumns = Array<{
	key: string,
	prop: string,
	prop_sub?: string,
	is_owner_display?: boolean,
	is_fc?: boolean,
	tooltip: string,
	hide?: boolean
}>;

type Props = {
	match: Object,
	history: Object,
	fetchLeague: Function,
	fetchLadder: Function,
	fetchTeam: Function,
	fetchRemovePlayer: Function,
	updateTeam: Function,
	clearTeamErrors: Function,
	fetchWaiverList: Function,
	fetchWaiverFree: Function,
	selected_team: Object,
	teams_by_id: Object,
	navigation: Object,
	team_players_count: Object,
	table: {
		basic: TTableColumns,
		coach: TTableColumns,
	},
	lineup_players: Object,
	league: Object,
	team_error?: string,
	selected_round: Object,
	actual_round: Object,
	players_by_id: TPlayersById,
	is_user_team: boolean,
	emergency: Object,
	positions_by_id: Object,
	has_assistant_coach: boolean,
	is_team_saving: boolean,
	rounds: Array<Object>,
	coach_players_by_id: TCoachPlayerStatsById,
	players: Array<TPlayerWithFixture>,
	is_active_match: boolean,
	is_league_started: boolean,
	is_preseason: boolean,
	coach_stats_list: TCoachStatsListReducer,
	user_team: Object,
	team_ids: Array<number>,
	trial_days_to_end: number,
	is_coach_trial_end: boolean,
	with_trial: boolean,
	setUserCoachBanner: typeof actions.setUserCoachBanner,
	coach_trial_popup: boolean,
	data_has_loaded: boolean,
	is_captains_enabled: boolean
};

type State = {
	leagues: Object,
	selected_team: Object,
	selected_team_id: number,
	player_row_menu_id: number,
	show_error: boolean,
	positions_to_substitute: number[],
	substitute_positions: number[],
	substitute_id: number,
	rfa_order_widget_open: boolean,
	is_coach_active: boolean,
	coach_type: string,
	fa_trade: {
		new_player_id: number,
		old_player_id: number
	},
	team_trade: TTeamsDraftTradesReducer,
	is_fa_trade: boolean,
	is_team_trade: boolean,
	show_team: boolean,
	is_swap_in_progress: boolean,
	remove_player_id: number,
	interval?: IntervalID | null
};

type TChangeRoute = {
	team_id?: number,
	round_id?: number
};
class TeamPage extends React.Component<Props, State> {
	state = {
		player_row_menu_id: 0,
		leagues: {},
		show_error: false,
		positions_to_substitute: [],
		substitute_id: 0,
		substitute_positions: [],
		rfa_order_widget_open: false,
		is_coach_active: false,
		coach_type: 'coaches-choice',
		fa_trade: {
			new_player_id: 0,
			old_player_id: 0
		},
		team_trade: {
			new_player_id: [],
			old_player_id: []
		},
		is_fa_trade: false,
		is_team_trade: false,
		show_team: true,
		is_swap_in_progress: false,
		remove_player_id: 0,
		interval: null
	};
	static defaultProps = {
		players: [],
	};
	ref = React.createRef();
	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'getPlayerScore',
			'handleTeamSelectChange',
			'handleRoundChange',
			'changeRoute',
			'getTableSection',
			'getTableRow',
			'handlePlayerMenu',
			'handleCaptain',
			'handleSubstitute',
			'handleViceCaptain',
			'handleEmergency',
			'handleErrorModalClose',
			'tryToSwap',
			'onToggleWaiverOrderWidget',
			'isInSubstitute',
			'getRowClassNames',
			'onTabChange',
			'setCoachType',
			'handleCoachSelectChange',
			'addOutTrade',
			'addInTrade',
			'cancelTradeRequest',
			'removeOutPlayer',
			'removeInPlayer',
			'reFetchData',
			'getControls',
			'handleConfirmRemovePlayerModal',
			'confirmRemovePlayer',
			'setUserCoachBanner',
			'fetchData'
		]);
	}
	componentDidMount() {
		this.fetchData();

		const interval = setInterval(this.fetchData, 60000);
		this.setState({ interval });
	}

	componentDidUpdate(prevProps) {
		const { match } = this.props;
		const { league_id, round_id, team_id } = match.params;

		if (
			_.get(prevProps, 'match.params.league_id') !== league_id ||
			_.get(prevProps, 'match.params.round_id') !== round_id ||
			_.get(prevProps, 'match.params.team_id') !== team_id
		) {
			this.reFetchData();
		}
	}

	componentWillUnmount() {
		// $FlowFixMe
		clearInterval(this.state.interval);
	}

	fetchData() {
		const {
				fetchLeague,
				fetchLadder,
				match,
				fetchWaiverList,
				fetchWaiverFree,
				fetchTeam
			} = this.props,
			{ league_id, team_id, round_id } = match.params;
		let fetch_ladder_params = { league_id };
		let fetch_team_params = { league_id };

		if(team_id) {
			fetch_team_params ={
				...fetch_team_params,
				id: team_id
			};
		}

		if (round_id) {
			fetch_ladder_params = {
				...fetch_ladder_params,
				round_id
			};
			fetch_team_params ={
				...fetch_team_params,
				round: round_id
			};
		}

		fetchLeague({
			id: league_id
		});
		fetchLadder(fetch_ladder_params);
		fetchWaiverList({
			league_id
		});
		fetchWaiverFree({
			league_id
		});
		fetchTeam(fetch_team_params);
	}

	get is_sidebar_open() {
		const { rfa_order_widget_open } = this.state;
		return rfa_order_widget_open;
	}
	getRowClassNames({ key, is_fc }) {
		let class_name = '';
		if (key !== 'avg') {
			class_name += ' hidden-mobile';
		}
		if (is_fc) {
			class_name += ' coach';
		}
		return class_name;
	}
	handleTeamSelectChange(event: Object) {
		const { value } = event.target,
			team_id = parseInt(value, 10);

		this.changeRoute({ team_id });
	}
	handleRoundChange(round_id) {
		this.changeRoute({ round_id });
	}
	changeRoute({ team_id = 0, round_id = 0 }: TChangeRoute) {
		const {
				history,
				match,
				selected_round: { id: selected_round_id },
				league: { team_id: user_team_id }
			} = this.props,
			{ league_id, round_id: url_round_id, team_id: url_team_id } = match.params;

		let new_team_id = team_id,
			new_round_id = round_id;

		if (!new_team_id) {
			new_team_id = url_team_id || user_team_id;
		}

		if (!new_round_id) {
			new_round_id = url_round_id || selected_round_id;
		}

		history.push(`/league/${league_id}/team/${new_team_id}/${new_round_id}`);
	}
	get component_to_show() {
		const { league } = this.props;
		const { is_team_trade, team_trade, show_team } = this.state;

		if (is_team_trade) {
			return (
				<OneColumnLayout width='1060px'>
					<TeamToTeamTrade
						league={league}
						cancelTradeRequest={this.cancelTradeRequest}
						team_trade={team_trade}
					/>
				</OneColumnLayout>
			);
		}

		return (
			<Layout sidebar_open={this.is_sidebar_open}>
				<div>
					{this.trades}

					{show_team ? (
						<React.Fragment>
							<div>
								{this.is_user_team ? this.trades_message : null}
								{this.team_header}
								{this.draft_table_header}
								<TableGrid>
									{ this.table_header }
									{ this.table_body }
								</TableGrid>
							</div>
							<DraftLegend/>
						</React.Fragment>
					): (
						<PlayersTable
							league={league}
							addOutTrade={this.addOutTrade}
							addInTrade={this.addInTrade}
							cancelTradeRequest={this.cancelTradeRequest}
							removeOutPlayer={this.removeOutPlayer}
							removeInPlayer={this.removeInPlayer}
							reFetchData={this.reFetchData}
							only_fa
							only_teams={false}
						/>
					)}
				</div>
				<div className="hidden-mobile">
					{league.id ? (
						<WaiverOrderWidget
							league_id={league.id}
							onToggle={ this.onToggleWaiverOrderWidget }
							widget_open={this.state.rfa_order_widget_open}
						/>
					) : null }
				</div>
			</Layout>
		);
	}
	get trades_message() {
		const { user_team } = this.props;
		const { players_margin } = user_team;
		const is_under_margin = players_margin < 1;
		if (!players_margin) {
			return null;
		}
		return (
			<TradesMessage>
				<Caution size={1.6} />
				<p>
					{is_under_margin ? (
						`Your team is in an invalid state, you need to add
						${Math.abs(players_margin)} player${players_margin === 1 ? '' : 's'}
						for your team to be complete`
					) : (
						`Your team is in an invalid state, you have until the next lockout
						to release
						${Math.abs(players_margin)} player${players_margin === 1 ? '' : 's'}.`
					)}

				</p>
				<div>
					<Tooltip
						icon_background="transparent"
						show_on_left
						title={'Tooltip'}
						children="Release players"
					/>
				</div>
			</TradesMessage>
		);
	}
	get remove_player_confirm_modal() {

		return (
			<ConfirmationModal
				header_text='Delist Player'
				body_text='Are you sure you want to delist this player?'
				confirmClick={this.confirmRemovePlayer}
				cancelClick={this.handleConfirmRemovePlayerModal}
				closeClick={this.handleConfirmRemovePlayerModal}
			/>
		);
	}
	get game_bar() {
		const {
			coach_players_by_id,
			selected_round,
			selected_team,
			league,
			is_team_saving,
			has_assistant_coach,
			is_active_match,
			is_league_started,
			players_by_id
		} = this.props;

		return league.id ? (
			<TeamGameBar
				coach_players_by_id={coach_players_by_id}
				selected_round={selected_round}
				selected_team={selected_team}
				league={league}
				is_team_saving={is_team_saving}
				has_assistant_coach={has_assistant_coach}
				is_active_match={is_active_match}
				is_league_started={is_league_started}
				players_by_id={players_by_id}
			/>
		) : null;
	}
	get round_slider() {
		const {
			rounds,
			league,
			selected_round,
			actual_round
		} = this.props;
		const { status, start_round, end_round } = league;
		if (status === 'scheduled') {
			return null;
		}
		const last_round = end_round > actual_round.id ? actual_round.id : end_round;
		const rounds_array = rounds.filter(round => {
			const { id } = round;
			return id >= start_round && id <= last_round;
		});

		return (
			<RoundSelector
				selected={selected_round.id}
				rounds={rounds_array}
				handleClick={this.handleRoundChange}
				round_aliases={getLeagueRoundAliases(league, rounds)}
			/>
		);
	}
	get draft_table_header() {
		const { is_coach_active } = this.state;
		const { coach_stats_list, selected_round: { status } } = this.props;

		if (status === 'complete') {
			if (is_coach_active) {
				this.setState({
					is_coach_active: false
				});
			}
			return null;
		}
		return (
			<DraftTableHeader
				onTabClick={this.onTabChange}
				isCoachActive={is_coach_active}
				selectOptions={coach_stats_list}
				setCoachType={this.setCoachType}
				onSelectChange={this.handleCoachSelectChange}
			/>
		);
	}
	get trades() {
		const { league, user_team } = this.props;
		const{
			fa_trade, team_trade,
			is_fa_trade, is_team_trade
		} = this.state;
		if (!is_fa_trade && !is_team_trade) {
			return null;
		}
		return (
			<PlayersOnTrade
				league={league}
				fa={fa_trade}
				team={team_trade}
				reFetchData={this.reFetchData}
				cancelRequest={this.cancelTradeRequest}
				removeOutPlayer={this.removeOutPlayer}
				removeInPlayer={this.removeInPlayer}
				user_team={user_team}
			/>
		);
	}
	get team_header() {
		const {
			selected_round,
			selected_team,
			teams_by_id,
			team_players_count,
			team_ids
		} = this.props;

		return (
			<TeamHeader
				round={selected_round}
				selected_team={selected_team}
				team_ids={team_ids}
				teams_by_id={teams_by_id}
				team_players_count={team_players_count}
				handleChange={this.handleTeamSelectChange}
			/>
		);
	}

	get is_user_team() {
		const { selected_team, league } = this.props;

		if (_.isEmpty(selected_team) || _.isEmpty(league)) {
			return false;
		}
		const { id } = selected_team,
			{ team_id } = league;

		if (!id || !team_id) {
			return false;
		}

		return id === team_id;

	};

	get is_past_round() {
		const { actual_round, selected_round } = this.props;

		return _.get(selected_round, 'id') < _.get(actual_round, 'id');
	}

	get error_modal() {
		const { team_error } = this.props;

		return (
			<ModalContainer header_text="Error" onClick={this.handleErrorModalClose}>
				<ModalInnerTitle>
					{team_error}
				</ModalInnerTitle>
			</ModalContainer>
		);
	}
	get table_keys():TTableColumns {
		const { is_coach_active, coach_type } = this.state;
		return is_coach_active ?
			_.get(this.props, `table.coach[${coach_type}]`, [])
				.filter(table_key => table_key.hide !== true) :
			this.props.table.basic;
	}
	get table_header() {
		const { is_league_started } = this.props;

		const cells = _.map(this.table_keys, ({ key, prop, tooltip, is_fc }) => (
			<PlayerTableCellWithTooltip key={key}
				width="50px"
				height="50px"
				basis={is_league_started ? '12%' : '14%'}
				className={this.getRowClassNames({ key, is_fc })}
			>
				<HeaderSpan className="column-name" >{key}</HeaderSpan>
				{tooltip && <ThToolTip text={tooltip} />}
			</PlayerTableCellWithTooltip>
		));

		return (
			<TableFlexHeading height="50px" is_coach={this.state.is_coach_active}>
				<PlayerTableCell
					mobile_width="40%"
					width="260px"
					height="50px"
					justify="flex-start"
				>
					Starting Side
				</PlayerTableCell>
				{is_league_started ? (
					<PlayerTableCell width="50px" basis="10%" height="50px">Score</PlayerTableCell>
				) : null}
				{ cells }
				{this.last_heading_cell}
			</TableFlexHeading>
		);
	}
	get last_heading_cell() {
		const { user_team } = this.props;
		const { players_margin } = user_team;

		if (players_margin > 0) {
			return (
				<PlayerTableCell width="60px" height="50px">Release</PlayerTableCell>
			);
		}
		return (
			<PlayerTableCellWithTooltip width="60px" height="50px">
				Action
				<ThToolTip text='Click to Expose Action Buttons' />
			</PlayerTableCellWithTooltip>
		);
	}
	get table_body() {
		const { selected_team, lineup_players } = this.props;
		const { lineup } = selected_team;
		const lineup_pure = _.omit(lineup, ['captain', 'vice_captain', 'bench', 'emergency']);
		const bench = _.get(lineup, 'bench');

		if (!lineup || _.isEmpty(lineup_players)) {
			return <LoadingSpinner />;
		}

		return (
			<TableFlexBody>
				{_.map(lineup_pure, this.getTableSection)}
				<BenchTitle>
					Bench
				</BenchTitle>
				{_.map(bench, id => this.getTableRow(
					{ id, is_bench: true, position_in_lineup: 0 }
				))}
			</TableFlexBody>
		);
	}

	getTableSection(line, position_in_lineup) {
		return line.map(id => this.getTableRow(
			{ id, is_bench: false, position_in_lineup: parseInt(position_in_lineup, 10) }
		));
	}

	// eslint-disable-next-line complexity
	getPlayerScore(player, lineup_players, captain, vice_captain) {
		const { selected_round, is_captains_enabled } = this.props;
		const default_case = (selected_round.status === "complete")? 'DNP': '--';
		const player_id = _.get(player, 'id');

		let score = _.get(player, `stats.scores.${selected_round.id}`, default_case);

		if (is_captains_enabled) {
			// check if player is captain
			if(player_id === captain && /[0-9]{1,}/.test(score)) {
				score = parseInt(score, 10) * 2;
			}
			// check if player is vice and cap is DNP
			else if(player_id === vice_captain) {
				if(
					captain &&
					_.get(lineup_players, `${captain}.stats.points_last_round`) === 'DNP' &&
					/[0-9]{1,}/.test(score)
				) {
					score = parseInt(score, 10) * 2;
				}
			}
		}

		return score;
	}

	getTableRow({ id, is_bench, position_in_lineup }) {
		if (_.eq(id, 0)) {
			return this.getEmptyTableRow({ is_bench, position_in_lineup });
		}

		const {
			lineup_players,
			league,
			selected_team: { lineup: { captain, vice_captain } },
			emergency: emg_array,
			is_league_started,
			has_assistant_coach,
			players,
			selected_round,
			is_captains_enabled
		} = this.props;
		const { substitute_id, is_swap_in_progress } = this.state;

		const player_with_full_info = _.find(players, { id:id });
		const player = lineup_players[id];
		const is_captain = isTrueBoth(is_captains_enabled, _.eq(captain, id));
		const is_vice_captain = isTrueBoth(is_captains_enabled, _.eq(vice_captain, id));
		const is_emergency_enabled = emg_array.includes(id);
		const is_in_substitute = this.isInSubstitute(position_in_lineup, player);
		const is_player_in_substitute = _.eq(substitute_id, id);
		const is_can_be_swapped = this.isCanBeSwapped({ 
			id, 
			is_in_substitute, 
			substitute_id, 
			is_player_in_substitute 
		});

		const onSubstitute = () => is_can_be_swapped 
			? this.tryToSwap({ id, position_in_lineup }) 
			: null;

		const is_emergency = isAllTrue([
			league.emergency,
			is_bench
		]);
		const position_in_lineup_text = _.get(player, 'position_in_lineup');

		return (
			<TableFlexRowStyled
				key={id}
				is_in_substitute={is_in_substitute}
				is_swap_in_progress={is_swap_in_progress}
				is_player_in_substitute={is_player_in_substitute}
				onClick={onSubstitute}
			>
				<PlayerTableCell
					mobile_width="40%"
					width="260px"
					height="60px"
					justify="flex-start"
				>
					<RotatedLabel
						is_captain={is_captain}
						is_vice_captain={is_vice_captain}
						is_emergency_enabled={is_emergency_enabled}
						is_emergency={is_emergency}
						text={_.eq(position_in_lineup_text, "EMG") ? 'INT': position_in_lineup_text}
						rotate="-90" />
					{player_with_full_info && 
						<PlayerInfo player={player_with_full_info} longer_name />}
					
				</PlayerTableCell>
				{is_league_started ? (
					<PlayerTableCell width="50px" basis="10%" height="60px">
						<p className={_.eq(selected_round.status, "active") &&
							player.is_playing_now ? 'live' : ''}>
							{this.getPlayerScore(player, lineup_players, captain, vice_captain)}
						</p>
					</PlayerTableCell>
				) : null}
				{_.map(this.table_keys, ({ key, prop, prop_sub, is_owner_display, is_fc }) => {
					const renderValue = () => (
						<React.Fragment>
							{_.get(player, prop, '--')} {prop_sub
								? `(${_.get(player, prop_sub, '--')})`
								: null
							}
						</React.Fragment>
					);
					return (
						<PlayerTableCell
							key={key} width="50px" height="60px"
							basis={is_league_started ? '12%' : '14%'}
							className={this.getRowClassNames({ key, is_fc })}
						>
							{ is_fc && !has_assistant_coach ? (
								<CoachLockIcon size=".875" />
							) : ( is_owner_display ?
								<OwnershipSpan
									className={`color${Math.sign(_.get(player, prop, '--'))}`}>
									{renderValue()}
								</OwnershipSpan> :
								renderValue())}
						</PlayerTableCell>
					);
				})}
				{this.getControls({ id, is_bench, position_in_lineup, owner: true })}

			</TableFlexRowStyled>
		);
	}
	getControls({ id, is_bench, position_in_lineup, owner }) {
		
		if (this.is_past_round) {
			return <PlayerTableCell width="60px" height="60px">
				<PlayerRowMenuNoAction>
					<StopIcon color={colors.icon_grey} />
				</PlayerRowMenuNoAction>
			</PlayerTableCell>;
		}

		if (!this.is_user_team) {
			return (
				<PlayerTableCell width="60px" height="60px">
					<PlayerRowMenuButton
						onClick={() => this.addInTrade({ id, is_user_team: false, owner })}
						background="#fff"
						is_shadow
					>
						<T color={colors.negative_value} />
					</PlayerRowMenuButton>
				</PlayerTableCell>
			);
		}
		const { user_team } = this.props;
		const { players_margin } = user_team;


		if (players_margin > 0) {
			return (
				<PlayerTableCell width="60px" height="60px">
					<PlayerRowMenuButton
						onClick={() => this.handleConfirmRemovePlayerModal({ id })}
						color={colors.negative_value}
						border={colors.negative_value}
						margin="0"
					>
						<D color={colors.negative_value} />
					</PlayerRowMenuButton>
				</PlayerTableCell>

			);
		}

		return this.getPlayerRowMenu(
			{ id, is_bench, position_in_lineup }
		);
	}
	getEmptyTableRow({ is_bench, position_in_lineup }) {
		const { positions_by_id, user_team } = this.props;
		const { substitute_id } = this.state;
		const is_in_substitute = this.isInSubstitute(position_in_lineup, {});
		const is_can_be_swapped = is_in_substitute && substitute_id;
		const swap_data = { id: 0, position_in_lineup };
		const onSubstitute = () => is_can_be_swapped ? this.tryToSwap(swap_data) : null;
		const substitute_object = {
			id: 0,
			is_bench,
			positions: [position_in_lineup],
			position_in_lineup
		};
		const position = positions_by_id[position_in_lineup];
		const { players_margin } = user_team;
		return (
			<TableFlexRowStyled
				key={_.uniqueId()}
				is_in_substitute={is_in_substitute}
				is_swap_in_progress={substitute_id}
				onClick={onSubstitute}
				background="#F6F6F6"
			>
				<PlayerTableCell
					mobile_width="40%"
					width="260px"
					height="60px"
					justify="flex-start"
				>
					<RotatedLabel
						text={position ? position.short_name : 'INT'}
						rotate="-90" />

					<BlankPlayerImage src={BlankPlayer} alt="player" />
				</PlayerTableCell>
				<BlankPlayerLabel>
					{is_bench ? (
						'This position is empty'
					) : (
						'This position is empty, check your bench to assign a player'
					)}
				</BlankPlayerLabel>
				<PlayerTableCell width="60px" height="60px">
					{players_margin < 0 ? (
						<PlayerRowMenuButton
							onClick={() => this.addOutTrade(
								{ id: 0, is_fa: true }
							)}
							color={colors.negative_value}
							border={colors.negative_value}
							margin="0"
						>
							<D color={colors.negative_value} />
						</PlayerRowMenuButton>
					) : (
						<PlayerRowMenuButton
							onClick={() => this.handleSubstitute(substitute_object)}
							background="#c0c0c0"
						>
							<S />
						</PlayerRowMenuButton>
					)}

				</PlayerTableCell>
			</TableFlexRowStyled>
		);
	}

	getPlayerRowMenu({ id, is_bench, position_in_lineup }) {
		const {
				lineup_players,
				league,
				selected_team: { lineup: { captain, vice_captain, emergency } },
				emergency: emg_array,
				positions_by_id,
				selected_round,
				is_captains_enabled,
				rounds
			} = this.props,
			{ player_row_menu_id } = this.state,
			player = lineup_players[id],
			is_show_player_row_menu = player_row_menu_id === id,
			is_captain = isTrueBoth(is_captains_enabled, captain === id),
			is_vice_captain = isTrueBoth(is_captains_enabled, vice_captain === id),
			is_emergency_enabled = league.emergency && is_bench,
			is_emergency = emg_array.includes(id),
			is_management_available = is_captain || is_vice_captain ?
				this.checkIsLeaderAvailable(id, 0) :
				this.checkIsManagementAvailable(id),
			emergency_position = is_emergency ? _.findKey(emergency, value => value === id) : 0;
		const positions = _.get(player, 'positions', []);

		return (
			<PlayerTableCell position="relative" width="60px" height="60px">
				{ is_show_player_row_menu ? (
					<PlayerRowMenuTeam id={id}
						onClose={() => this.handlePlayerMenu(id)}
						handleCaptain={this.handleCaptain}
						handleSubstitute={this.handleSubstitute}
						handleViceCaptain={this.handleViceCaptain}
						handleEmergency={this.handleEmergency}
						addOutTrade={this.addOutTrade}
						captains={league.captains}
						is_bench={is_bench}
						is_emergency_enabled={is_emergency_enabled}
						positions={positions}
						positions_by_id={positions_by_id}
						position_in_lineup={position_in_lineup}
						is_captain={is_captain}
						is_vice_captain={is_vice_captain}
						is_emergency={is_emergency}
						emergency_position={parseInt(emergency_position, 10)}
						is_management_available={is_management_available}
						round_status={selected_round.status}
						rounds={rounds}
					/>
				) : (
					<DivLikeAButton onClick={() => this.handlePlayerMenu(id)}>
						<More color={colors.darkGrey} />
					</DivLikeAButton>
				) }
			</PlayerTableCell>
		);
	}

	handlePlayerMenu(id) {
		let { player_row_menu_id } = this.state;

		if (player_row_menu_id === id) {
			this.clearEmergency();

			return this.setState({
				player_row_menu_id: 0
			});
		}

		this.setState({
			player_row_menu_id: id
		});
	}
	handleCaptain(player_id) {
		return this.handleLeader({
			selected_leader: 'captain',
			opposite_leader: 'vice_captain',
			player_id
		});
	}
	handleViceCaptain(player_id) {
		return this.handleLeader({
			selected_leader: 'vice_captain',
			opposite_leader: 'captain',
			player_id
		});
	}
	handleEmergency({ player_id, position }) {
		const { selected_team, updateTeam } = this.props,
			{ lineup, id } = selected_team,
			{ emergency = {} } = lineup,
			old_emergency = parseInt(_.invert(emergency)[player_id], 10);

		if (!this.checkIsManagementAvailable(player_id)) {
			return null;
		}

		if (old_emergency) {
			emergency[old_emergency] = 0;
			if (position === old_emergency) {
				player_id = 0;
			}
		}

		updateTeam({
			old_lineup: {
				...lineup
			},
			lineup: {
				...lineup,
				emergency: {
					...emergency,
					[position]: player_id
				}
			}, id
		});
	}
	handleLeader({ selected_leader, opposite_leader, player_id }) {
		const { selected_team, updateTeam } = this.props,
			{ lineup, id } = selected_team;
		const { captain, vice_captain } = lineup;
		let selected_leader_id = selected_leader === 'captain' ? captain : vice_captain;
		let opposite_leader_id = opposite_leader === 'captain' ? captain : vice_captain;

		if (!this.checkIsLeaderAvailable(player_id, selected_leader_id)) {
			return null;
		}

		if (opposite_leader_id === player_id && selected_leader) {
			opposite_leader_id = selected_leader_id;
		}

		updateTeam({
			old_lineup: {
				...lineup
			},
			lineup: {
				...lineup,
				[selected_leader]: player_id,
				[opposite_leader]: opposite_leader_id
			}, id
		});
	}
	checkIsLeaderAvailable(player_id, selected_leader_id) {
		const { selected_round: { status }, league } = this.props,
			{ status: league_status } = league,
			is_global_manageable = this.checkIsManagementAvailable(player_id);

		if (is_global_manageable && status === 'active' && league_status !== 'scheduled') {
			return false;
		}

		return is_global_manageable && selected_leader_id !== player_id;
	}
	checkIsManagementAvailable(player_id) {
		const { selected_round, players_by_id, league } = this.props,
			{ status } = selected_round,
			{ status: league_status, lockout } = league,
			player = players_by_id[player_id];

		if (league_status === 'scheduled') {
			return true;
		}

		if (!lockout && status !== 'scheduled') {
			return false;
		}

		return player && !player.locked;
	}

	isInSubstitute(position_in_lineup, player) {
		const { 
			// All of the possible positions of the out sub
			substitute_positions,
			// The current lineup position of the out sub (or all of 
			// their positions, if they are on the bench)
			positions_to_substitute
		} = this.state;

		if (position_in_lineup === 0) {
			// In-sub player is on the bench
			// Check if they share a position with the out-sub
			return _.size(_.intersection(positions_to_substitute, _.get(player, 'positions')));
		}
		else {
			// In-sub is on the field
			// Check if the out-player would fit the in-player's current position
			const out_matches_in = matchesPositions(
				[ position_in_lineup ],
				 substitute_positions
			);
			// Check if the in-player would fit the out-player's current position (or 
			// any one of their positions, if on the bench)
			const in_matches_out = matchesPositions(
				positions_to_substitute,
				_.get(player, 'positions', [])
			);
			return in_matches_out && out_matches_in;
		}
	}
	isCanBeSwapped({ id, is_in_substitute, substitute_id, is_player_in_substitute }) {
		const is_can_be_swapped = this.checkIsManagementAvailable(id) &&
			is_in_substitute;
		if (!substitute_id) {
			return is_can_be_swapped;
		}
		return is_can_be_swapped && substitute_id && !is_player_in_substitute;
	}
	handleSubstitute({ id, is_bench, positions, position_in_lineup }) {
		const positions_to_substitute = position_in_lineup === 0 ? positions : [position_in_lineup];
		const { is_swap_in_progress } = this.state;

		if (is_swap_in_progress) {
			return this.clearEmergency();
		}

		if (this.checkIsManagementAvailable(id)) {
			this.setState({
				positions_to_substitute,
				substitute_id: id,
				substitute_positions: positions,
				is_swap_in_progress: true
			});
		}
		if (id === 0) {
			this.setState({
				positions_to_substitute,
				substitute_positions: [...positions_to_substitute],
				is_swap_in_progress: true
			});
		}
	}
	swapPlayersOnField({ id, substitute_id, lineup, position_in_lineup, positions_to_substitute }) {
		const players_id = [id, substitute_id];
		const swapPlayersOnFound = player_id => {
			let found = players_id.includes(player_id),
				inverted_index = players_id.indexOf(player_id) ^ 1;

			return found ? players_id[inverted_index] : player_id;
		};
		const swapPlayerWithZero = ({ lineup, position_in_lineup, substitute_id }) =>  {
			const line = lineup[position_in_lineup];

			if (line.includes(0)) {
				const zero_index = line.indexOf(0);
				line[zero_index] = substitute_id;
				return {
					...lineup,
					[position_in_lineup]: line
				};
			}
		};
		if (players_id.includes(0)) {
			if (id === 0 && positions_to_substitute[0] === 0) {
				return swapPlayerWithZero({ lineup, position_in_lineup, substitute_id });

			}
			if (substitute_id === 0 && position_in_lineup === 0) {
				return swapPlayerWithZero(
					{ lineup, position_in_lineup: positions_to_substitute[0], substitute_id: id }
				);
			}
		}

		return _.chain(lineup)
			.omit(['captain', 'vice_captain', 'emergency'])
			.mapValues(value => value.map(swapPlayersOnFound))
			.value();
	}
	swapEmergency({ id }) {
		const { substitute_id } = this.state;
		const { selected_team, players_by_id } = this.props;
		let { lineup: { emergency, bench } } = selected_team;

		if (!emergency) {
			return {};
		}

		// Finds the position the given id is an emergency for, if it is one
		const findEmergency = id => id !== 0 
			? _.findKey(emergency, value => value === id) 
			: undefined;

		// Checks if the given player is currently on the bench
		const onBench = id => _.includes(bench, id);

		// Gives in_id the emergency position of the out_id, if it had one and
		// the in_id player can be the emg for the given position
		const swapEmergency = (in_id, out_id) => {
			let emg_pos = findEmergency(out_id);

			// Only do the swap if the player is actually on the bench
			if (emg_pos && onBench(out_id)) {
				// Convert from string to a number so that can find
				// position in player's array of positions
				const emg_pos_num = parseInt(emg_pos, 10);
				// Check if the player being swapped in as emg
				// is able to be emg for that position
				const positions =  _.get(players_by_id, [in_id, 'positions'], []);
				const valid_emg_pos = !_.isNaN(emg_pos_num) 
					&& _.includes(positions, emg_pos_num);

				emergency = {
					...emergency,
					// if the player being swapped in is invalid
					// for pos, just remove the emergency
					[emg_pos]: valid_emg_pos ? in_id : 0
				};
			}
		};

		// If both  players are emergencies (i.e. on bench), 
		// don't bother swapping
		if (onBench(id) && onBench(substitute_id)) {
			return { ...emergency };
		}

		swapEmergency(substitute_id, id);
		swapEmergency(id, substitute_id);

		return emergency || {};
	}
	findLeader(id) {
		const { selected_team: { lineup: { captain, vice_captain } } } = this.props;
		return _.findKey({ captain, vice_captain }, player_id => player_id === id);
	}
	tryToSwap({ id, position_in_lineup }) {
		const { substitute_id, positions_to_substitute } = this.state,
			{ updateTeam, selected_team: { lineup, id: team_id } } = this.props,
			{ emergency, bench } = lineup,
			what_leader_out = this.findLeader(substitute_id),
			what_leader_in = this.findLeader(id),
			swap_data = { id, substitute_id, lineup, position_in_lineup, positions_to_substitute }
		;


		let new_lineup = {
			...lineup,
			...this.swapPlayersOnField(swap_data)
		};

		if (!id || !substitute_id) {
			new_lineup = {
				...new_lineup,
				bench: _.filter(bench, bench_id => ![id, substitute_id].includes(bench_id))
			};
		}

		if (emergency) {
			new_lineup = {
				...new_lineup,
				emergency: {
					...emergency,
					...this.swapEmergency({ id })
				}
			};
		}

		if (what_leader_out) {
			new_lineup = {
				...new_lineup,
				[what_leader_out]: id
			};
		}
		if (what_leader_in) {
			new_lineup = {
				...new_lineup,
				[what_leader_in]: substitute_id
			};
		}

		updateTeam({
			old_lineup: {
				...lineup
			},
			lineup: {
				...new_lineup
			},
			id: team_id
		});

		this.clearEmergency();
	}
	handleErrorModalClose() {
		const { clearTeamErrors } = this.props;
		clearTeamErrors();
	}
	handleCoachSelectChange(event) {
		const { value: coach_type } = event.target;
		this.setState({ coach_type });
	}
	onToggleWaiverOrderWidget() {
		const rfa_order_widget_open = !this.state.rfa_order_widget_open;
		this.setState({ rfa_order_widget_open });
	}
	handleConfirmRemovePlayerModal({ id }) {
		this.setState({
			remove_player_id: id || 0
		});
	}
	clearEmergency() {
		this.setState({
			positions_to_substitute: [],
			substitute_id: 0,
			is_swap_in_progress: false
		});
	}
	onTabChange(){
		const { is_coach_active } = this.state;
		this.setState({ is_coach_active: !is_coach_active });
	}
	setCoachType(event) {
		const { value } = event.target;
		this.setState({ coach_type: value });
	}

	// Trades

	reFetchData() {
		this.cancelTradeRequest();

		const {
				fetchLadder,
				fetchWaiverList,
				fetchWaiverFree,
				fetchTeam,
				match,
			} = this.props,
			{ league_id, team_id, round_id } = match.params;
		let fetch_ladder_params = { league_id };
		let fetch_team_params = { league_id };

		if(team_id) {
			fetch_team_params ={
				...fetch_team_params,
				id: team_id
			};
		}

		if (round_id) {
			fetch_ladder_params = {
				...fetch_ladder_params,
				round_id
			};
			fetch_team_params = {
				...fetch_team_params,
				round: round_id
			};
		}

		fetchLadder(fetch_ladder_params);
		fetchWaiverList({
			league_id
		});
		fetchWaiverFree({
			league_id
		});
		fetchTeam(fetch_team_params);
	}
	addOutTrade({ id, is_fa }) {
		if (is_fa) {
			const { fa_trade } = this.state;
			this.setState({
				fa_trade: {
					...fa_trade,
					old_player_id: id
				},
				show_team: false,
				is_fa_trade: true
			});
		}
		else {
			const { team_trade } = this.state;
			const { old_player_id } = team_trade;
			this.setState({
				team_trade: {
					...team_trade,
					old_player_id: _.xor(old_player_id, [id]),
				},
				is_team_trade: true
			});
		}
	}
	addInTrade({ id, is_user_team, owner }) {
		if (owner) {
			const { team_trade } = this.state;
			const { selected_team: { id: owner_id } } = this.props;
			const { new_player_id } = team_trade;
			this.setState({
				team_trade: {
					...team_trade,
					new_player_id: _.xor(new_player_id, [id]),
					owner_id
				},
				is_team_trade: true
			});
		}
		else {
			const { fa_trade } = this.state;
			this.setState({
				fa_trade: {
					...fa_trade,
					new_player_id: id
				},
				is_fa_trade: true,
				show_team: false
			});
		}
	}
	cancelTradeRequest() {
		this.setState({
			fa_trade: {
				new_player_id: 0,
				old_player_id: 0
			},
			team_trade: {
				new_player_id: [],
				old_player_id: []
			},
			is_fa_trade: false,
			is_team_trade: false,
			show_team: true,
		});
	}
	removeOutPlayer({ id }) {
		const { is_fa_trade, is_team_trade, fa_trade, team_trade } = this.state;
		if (is_fa_trade) {
			const is_fa_trade_remove = fa_trade.new_player_id === 0;

			this.setState({
				fa_trade: {
					...fa_trade,
					old_player_id: 0
				},
				is_fa_trade: !is_fa_trade_remove
			});
		}
		if (is_team_trade) {
			const { new_player_id, old_player_id } = team_trade;
			const is_trade_remove = _.size(new_player_id.filter(id => id !== 0)) === 0;
			this.setState({
				team_trade: {
					...team_trade,
					old_player_id: _.xor(old_player_id, [id])
				},
				is_team_trade: !is_trade_remove

			});
		}
	}
	removeInPlayer({ id }) {
		const { is_fa_trade, is_team_trade, fa_trade, team_trade } = this.state;
		if (is_fa_trade) {
			const is_fa_trade_remove = fa_trade.old_player_id === 0;

			this.setState({
				fa_trade: {
					...fa_trade,
					new_player_id: 0
				},
				is_fa_trade: !is_fa_trade_remove

			});
		}
		if (is_team_trade) {
			const { new_player_id, old_player_id } = team_trade;
			const is_trade_remove = _.size(old_player_id.filter(id => id !== 0)) === 0;

			this.setState({
				team_trade: {
					...team_trade,
					new_player_id: _.xor(new_player_id, [id])
				},
				is_team_trade: !is_trade_remove
			});
		}
	}
	confirmRemovePlayer() {
		const { fetchRemovePlayer, league: { team_id } } = this.props;
		const { remove_player_id } = this.state;
		this.handleConfirmRemovePlayerModal({ id: 0 });
		fetchRemovePlayer({
			team_id,
			player_id: remove_player_id
		});
		this.scrollToComponent();
	}
	scrollToComponent() {
		if (this.ref.current) {
			this.ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'center',
			});
		}
	}

	get shouldRedirectToPreDraft() {
		const { league } = this.props;
		return league.draft_status === 'scheduled';
	}

	setUserCoachBanner() {
		const { setUserCoachBanner } = this.props;
		setUserCoachBanner();
	}

	render() {
		const {
			team_error, has_assistant_coach, league, trial_days_to_end, is_coach_trial_end,
			with_trial, coach_trial_popup
		} = this.props;
		const { is_fa_trade, remove_player_id } = this.state;
		const data_array = ['rounds', 'players', 'squads', 'venues'];
		if (has_assistant_coach) {
			data_array.push('coach_players');
		}

		if (is_fa_trade) {
			this.scrollToComponent();
		}

		if (this.shouldRedirectToPreDraft) {
			return <Redirect to={`/league/${league.id}/team/pre-draft`} />;
		}

		return (
			<div ref={this.ref}>
				<AdsContainer>
					<Ad
						adUnit='myleagues/myteam'
						size='top'
					/>
				</AdsContainer>
				{ is_fa_trade ? <TopBar league={league} /> : (
					<React.Fragment>
						{this.game_bar}
						<CoachBanner
							trial_days_to_end={trial_days_to_end}
							is_coach_trial_end={is_coach_trial_end}
							with_trial={with_trial}
							coach_trial_popup={coach_trial_popup}
							handleClick={this.setUserCoachBanner}
						/>
						{this.round_slider}
					</React.Fragment>
				)}
				{team_error ? this.error_modal : null}
				<JsonFetcher fetch={data_array}  interval={60000} />
				{this.component_to_show}
				{remove_player_id ? this.remove_player_confirm_modal : null}
				<AdsContainer>
					<Ad
						adUnit='myleagues/myteam'
						size='bottom'
					/>
				</AdsContainer>
			</div>
		);
	}
}

type PropsMapStateToProps = {
	match: {
		params: {
			team_id?: number,
			league_id: number,
			round_id?: number
		}
	}
};

// eslint-disable-next-line complexity
const mapStateToProps = (state, props: PropsMapStateToProps) => {
	const team_id = parseInt(_.get(props, 'match.params.team_id', 0), 10);
	const round_id = parseInt(_.get(props, 'match.params.round_id', 0), 10);
	const selected_team = selectors.getSelectedTeamWithEmptyPos(state, props, team_id);
	const actual_round = selectors.rounds.getActualRound(state);
	const is_preseason = actual_round ? actual_round.id < 2 : false;
	const rounds = selectors.rounds.getRounds(state);
	const stats_table_round_id = is_preseason ? _.last(rounds).id : actual_round.id;
	const league = selectors.leagueDraft.getLeague(state, props);
	const players =  selectors.players.getExtendedPlayersArrayWithOwners(state, props);

	const data_has_loaded = !state.rounds.is_pending
		&& !state.players.is_pending
		&& !state.squads.is_pending
		&& !state.venues.is_pending
		&& !state.leagues.show.is_pending
		&& !state.leagues.ladder.is_pending
		&& !state.leagues.waiver_list.is_pending
		&& !state.leagues.waiver_free.is_pending
		&& state.teamsDraft.user_team;

	return {
		players,
		has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
		trial_days_to_end: selectors.getTrialDaysToEnd(state),
		is_coach_trial_end: selectors.isCoachTrialEnd(state),
		with_trial: selectors.getWithTrial(state),
		coach_trial_popup: state.user.coach_trial_popup,
		players_by_id: state.players.by_id,
		selected_round: selectors.rounds.getSelectedRound(state, round_id),
		actual_round,
		is_pending_players: state.players.is_pending,
		positions_by_id: state.positions.by_id,
		rounds,
		teams_by_id: state.leagues.teams_by_id,
		team_ids: league.teams,
		league,
		selected_team,
		team_players_count: selectors.complex.team.getTeamPlayersCount(state, team_id),
		lineup_players: selectors.complex.team.getLineupPlayers(state, team_id),
		team_error: state.teamsDraft.error,
		emergency: selectors.complex.team.getEmergency(state, props, team_id),
		is_team_saving: state.teamsDraft.is_team_saving,
		ladder: state.leagues.ladder,
		coach_players_by_id: state.players.coach_by_id,
		is_active_match: selectors.rounds.isActiveMatch(state, round_id),
		is_league_started: selectors.leagueDraft.isLeagueStarted(state, props),
		coach_stats_list: state.coachStatsList,
		user_team: state.teamsDraft.user_team,
		is_captains_enabled: selectors.isCaptainsEnabled(state, props),
		data_has_loaded,
		table: {
			basic: basicTable,
			coach: _.mapValues(coach_player_stats(stats_table_round_id, is_preseason), values =>
				_.map(values, value => {
					return {
						...value,
						is_fc: true
					};
				}))
		}
	};
};

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague,
	updateTeam: actions.teamsDraft.postTeamUpdate,
	clearTeamErrors: actions.teamsDraft.clearTeamErrors,
	fetchLadder: actions.leagueDraft.ladderDraftLeague,
	fetchWaiverList: actions.leagueDraft.fetchWaiverList,
	fetchWaiverFree: actions.leagueDraft.fetchWaiverFree,
	fetchTeam: actions.teamsDraft.fetchTeam,
	fetchRemovePlayer: actions.teamsDraft.fetchRemovePlayer,
	setUserCoachBanner: actions.setUserCoachBanner
};

export const Team = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps,
)(TeamPage));

export default Team;


// WEBPACK FOOTER //
// ./src/pages/league/Team.js